<template>
  <div class="is-teacher flex min-h-screen w-full flex-col justify-between bg-violet-10 pt-navbar-height">
    <nav
      class="
        fixed left-0 top-0 z-30 flex w-full select-none items-center justify-start py-6
        pr-container-desktop-level-2 text-lg
        teacher:text-violet-text
        student:text-white
      "
      role="navigation"
    >
      <div class="shrink-0.5 grow-0 basis-container-desktop-level-4 pl-container-desktop-level-2 pr-4">
        <a
          :href="home"
          aria-label="Home"
          class="group shrink-0 grow-0 ring-offset-8 focus:outline-none"
        >
          <IconLogo
            class="h-7 ring-offset-4 group-focus-visible:ring-2 group-focus-visible:ring-focusTeacher"
            type="teacher"
          />
        </a>
      </div>
      <button
        v-if="auth?.user"
        type="button"
        class="ml-auto"
        @click="auth.logout()"
      >
        Logout
      </button>
    </nav>

    <EnvironmentOverlay />
    <UiGlobalNotifications />

    <Container indent="level-3" class="text-violet-text">
      <main>
        <h1
          class="mt-32 typo-heading-2xl-bold"
          v-html="({
            402: $t('general.not_trial'),
            403: $t('errors.403'),
            404: $t('errors.404'),
            405: $t('errors.405'),
          }[error?.statusCode as number])
            || $t('errors.general')
          "
        />
        <div class="mb-12 mt-2 opacity-50">
          Fehler Code: {{ error?.statusCode }}
        </div>
        <UiButton
          variant="big"
          @click="clearError({ redirect: home })"
        >
          Zurück zur Startseite
        </UiButton>

        
      </main>
    </Container>

    <AppFooter />
  </div>
</template>

<script setup lang="ts">
import type { NuxtError } from '#app'

const props = defineProps<{
  error: NuxtError
}>()

console.error('Caught on error page:', props.error)

useHead({ title: 'Fehler – LernWege' })

const auth = useAuthStore()
const cms = useCmsStore()
const router = useRouter()

await Promise.all([auth.init(), cms.fetch()])

const home = router.resolve(auth.homepage).href
</script>
